import authorized from "@/middleware/authorized"
import paid from '@/middleware/paid'
import store from '@/store'

export default {
    path: '/templates',
    meta: { middleware: [authorized, paid], layout: "default", rights: ['treatment_templates'] },
    component: () => import('../components/pages/templates/TemplatesGeneral.vue'),
    children: [
        {
            path: '',
            redirect: () => {
                if(store.state.auth.rights.includes('dental')) return { path: '/templates/text' }
                return { path: '/templates/plan' }
            }
        },
        {
            path: 'text', name: "TextTemplates",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['treatment_templates', 'dental'] },
            component: () => import('../components/pages/templates/TextTemplates.vue')
        },
        {
            path: 'treatment', name: "TreatmentTemplates",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['treatment_templates', 'dental'] },
            component: () => import('../components/pages/templates/TreatmentTemplates.vue')
        },
        {
            path: 'treatment_categories', name: "TreatmentTemplatesCategories",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['treatment_templates', 'dental'] },
            component: () => import('../components/pages/templates/TreatmentTemplatesCategories.vue')
        },
        {
            path: 'agreements', name: "AgreementTemplates",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['agreements'] },
            component: () => import('../components/pages/templates/AgreementTemplates.vue')
        },
        {
            path: 'agreement_categories', name: "AgreementTemplateCategories",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['agreements'] },
            component: () => import('../components/pages/templates/AgreementTemplateCategories.vue')
        },
        {
            path: 'contracts', name: "ContractTemplates",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['contracts'] },
            component: () => import('../components/pages/templates/ContractTemplates.vue')
        },
        {
            path: 'plan', name: "PlanTreatmentTemplates",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['treatment_templates'] },
            component: () => import('../components/pages/templates/PlanTreatmentTemplates.vue')
        },
        {
            path: 'diagnosis', name: "TextTemplatesDiagnoses",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['treatment_templates'] },
            component: () => import('../components/pages/templates/TextTemplatesDiagnosis.vue')
        },
        {
            path: 'message', name: "SMSTemplates",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['crm'] },
            component: () => import('../components/pages/templates/SMSTemplates.vue')
        },
        {
            path: 'official_whatsapp', name: "OfficialWhatsappTemplates",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['official_whatsapp'] },
            component: () => import('../components/pages/templates/OfficialWhatsappTemplates.vue')
        },
    ]
}
